<template>
  <div id="whats-lifefullness" class="mx-auto max-w-screen-xl">
    <MoleculesLoadingOverlay v-if="loading" />
    <Organisms v-else :organisms="organisms" />
    <OrganismsModalForm>
      <header class="mb-4">
        <h2 class="mb-4 text-4xl font-semibold text-black font-archer">
          Be the First
        </h2>
        <p v-if="!isFormSubmitted" class="text-lg text-gray-500">
          Please provide us your information and we will get back to you.
        </p>
      </header>
      <FormsHubSpotForm
        :form="{ id: '767c334f-0893-4757-8fa6-fd4b253bd691' }"
        @submit="isFormSubmitted = true"
      />
    </OrganismsModalForm>
  </div>
</template>

<style>
#whats-lifefullness {
  #lifefullness-written-graph {
    @apply max-w-5xl mx-auto;
  }

  .split-content {
    .text {
      @apply flex flex-col;

      h2 {
        @apply text-5xl font-bold;
      }

      h4 {
        @apply -order-1 uppercase text-bc-blue text-[17px] font-bold mb-2;
      }

      p {
        @apply pb-4;
      }
    }
  }

  #lifefullness-logo {
    img {
      @apply mx-auto;
    }
  }

  .flexible-content-columns {
    @apply px-4;

    img {
      @apply aspect-square mb-8;
    }

    h3 {
      @apply text-3xl font-semibold px-4 mb-4;
    }

    .description {
      @apply px-4 text-center;
    }
  }

  .neighborhoods-map {
    h2 {
      @apply font-semibold max-w-xl mx-auto;
    }

    .button-1 {
      @apply uppercase text-gray-500;
    }
  }
}
</style>

<script setup>
import { useAsyncQuery } from "#imports";
import { GET_ORGANISMS } from "~/graphql/GetOrganisms";
import { storeToRefs } from "pinia";
const breadcrumbs = useBreadcrumbs();
const { breadcrumbsList } = storeToRefs(breadcrumbs);
const modalForm = useModalForm();
const isFormSubmitted = ref(false);

const { data, pending, error } = await useAsyncQuery(GET_ORGANISMS, {
  uri: "/lifestyle/whats-lifefullness/",
});

const organisms = computed(() => {
  return data.value?.organisms?.hlOrganisms?.hlOrganism ?? [];
});

const loading = pending;

breadcrumbsList.value = [];

onMounted(() => {
  window.addEventListener(
    "hashchange",
    () => {
      if (window.location.hash === "#modal-form") {
        modalForm.openModal();
        window.location.hash = "";
      }
    },
    false,
  );

  addTriggers();
});

const addTriggers = () => {
  const modalFormTriggers = document.querySelectorAll("a[href$='#modal-form']");

  modalFormTriggers.forEach((node) => {
    // Clone & replace node to remove existing event listeners
    const clonedNode = node.cloneNode(true);
    node.parentNode.replaceChild(clonedNode, node);

    clonedNode.addEventListener("click", (event) => {
      // Add event listener
      event.preventDefault();
      modalForm.openModal();
    });
  });
};

onUpdated(() => {
  addTriggers();
});
</script>
